import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './index.css'; // Añadir esta línea para importar Tailwind CSS

const app = createApp(App);
app.use(router);
app.mount('#app');
